export default __webpack_public_path__ + "static/N0152-866c15405b3bdc23db7b8e8f53f95d8b.png";